import React, { useEffect, useState } from "react";
import useLogin from "../hooks/useLogin";
import { checkIfAuthenticated } from "../utils/utils";
import { LOGIN } from "../config/apiConfig";
import { GoAlertFill } from "react-icons/go";
import { Button } from "flowbite-react";
import { AiOutlineLoading } from "react-icons/ai";
import { Link } from "react-router-dom";

const LoginPage = () => {
  if (checkIfAuthenticated()) {
    window.location.href = "/queries/credits";
  }
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { loading, error, isLoggedIn, login } = useLogin(LOGIN.POST_LOGIN);
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await login(email, password);

      if (isLoggedIn) window.location.href = "/queries/credits";
    } catch (error) {
      console.log(error.response.data.message);
    }
  };

  let logoSrc;

  switch (true) {
    case window.location.href.includes("datacredi"):
      logoSrc = "/assets/data-credi/logo_branco.png";
      break;
    case window.location.href.includes("nexusid"):
      logoSrc = "/assets/nexus-id/logo_branco.png";
      break;
    default:
      logoSrc = "/assets/logo_branco.png";
      break;
  }

  let title;

  switch (true) {
    case window.location.href.includes("datacredi"):
      title = "DataCredi";
      break;
    case window.location.href.includes("nexusid"):
      title = "NexusID";
      break;
    default:
      title = "CrediAvalia";
      break;
  }

  return (
    <section
      className="flex flex-col md:flex-row bg-primary-300"
      style={{ height: "100vh" }}
    >
      <div className="h-full bg-primary-300 p-8 flex-1 rounded-xl relative">
        <div className="relative mt-10 pt-20">
          <img
            src={logoSrc}
            className="mx-auto mt-10 w-60 hidden md:block"
            loading="lazy"
          />
          <div className=" text-white text-center mt-5">
            <div className="font-semibold text-xl md:text-2xl">
              Seja bem vindo ao <br /> Sistema da{" "}
              <span className="color-black">{title}!</span>
            </div>
            <div className="mt-4 text-sm md:text-base">
              <span className="font-semibold">
                Sua empresa com o melhor sistema para análise de crédito.
              </span>
              <br />
              Acesse de forma simples e segura para obter informações essenciais
              e tomar decisões com confiança.
            </div>
          </div>
        </div>
      </div>
      <div className="flex-1 h-full bg-white p-8 rounded-lg">
        <div className="font-semibold text-2xl mb-4 mt-10">Login</div>
        <div className=" text-base mb-10">
          Faça o login para utilizar o sistema.
        </div>
        <form className="space-y-4 md:space-y-6" onSubmit={handleSubmit}>
          <div>
            <label
              for="username"
              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
            >
              E-mail / Cod. de acesso
            </label>
            <input
              type="text"
              name="email"
              id="email"
              className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div>
            <label
              for="password"
              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
            >
              Senha
            </label>
            <input
              type="password"
              name="password"
              id="password"
              placeholder="••••••••"
              className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          {error && (
            <div className="bg-red-200 rounded-sm px-1 text-xs py-1 flex gap-2 items-center text-red-600">
              <GoAlertFill color="var(--primary)" />{" "}
              <span>
                {error?.response?.data?.message ||
                  "Erro ao tentar realizar o login!"}
              </span>
            </div>
          )}
          <div className="flex items-center justify-end">
            <Link
              to="/recuperar-senha"
              className="text-sm font-medium text-primary-600 hover:underline dark:text-primary-500"
            >
              Esqueceu a senha?
            </Link>
          </div>
          <Button
            type="submit"
            className="w-fit text-white bg-primary-600 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-10 py-1 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800 primary"
            isProcessing={loading}
            processingSpinner={
              <AiOutlineLoading className="h-6 w-6 animate-spin" />
            }
            disabled={loading}
          >
            Entrar
          </Button>
        </form>
      </div>
    </section>
  );
};

export default LoginPage;
